import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type {
  LocationTemplate,
  ApplyTemplatePayload,
  ApplyTemplateResult,
} from '@/lib/types';

export function useLocationTemplates() {
  return useQuery({
    queryKey: queryKeys.locationTemplates.list(),
    queryFn: async (): Promise<LocationTemplate[]> => {
      const response = await apiClient.get<LocationTemplate[]>(
        '/api/v1/cf-location-templates/'
      );
      return response.data;
    },
  });
}

export function useApplyTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      locationId,
      payload,
    }: {
      locationId: number;
      payload: ApplyTemplatePayload;
    }): Promise<ApplyTemplateResult> => {
      const response = await apiClient.post<ApplyTemplateResult>(
        `/api/v1/cf-locations/${locationId}/apply-template/`,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.zones.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.spots.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.cfLocations.all });
    },
  });
}
